// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chart-container[data-v-6db60751]{margin:auto;position:relative;width:100%}", "",{"version":3,"sources":["webpack://./resources/client/components/charts/ChartBar.vue"],"names":[],"mappings":"AAEA,kCAEE,WAAA,CADA,iBAAA,CAEA,UADF","sourcesContent":["\n\n.chart-container {\n  position: relative;\n  margin: auto;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
